import React from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";

const Chatpop = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  // Use portal to render to body - escapes any stacking context
  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 chat-login-popup">
      <div
        className="p-6 rounded-2xl bg-gray-800/20 backdrop-blur-md text-textPrimary w-[90%] sm:w-[400px]"
        style={{
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(55, 65, 81, 0.2)',
          boxShadow: 'var(--shadow-box)'
        }}
      >
        <h2 className="text-xl font-semibold mb-4 text-center">Join to Access Chatty</h2>
        <p className="text-gray-300 text-sm mb-4 text-center">
          Create an account or log in to start chatting with Chatty.
        </p>

        <div className="flex flex-col space-y-3">
          {/* ✅ Sign Up links to /register */}
          <Link
            to="/register"
            className="btn-3d-dark w-full text-center"
          >
            Sign Up
          </Link>

          {/* ✅ Login links to /login */}
          <Link
            to="/login"
            className="btn-3d-dark w-full text-center"
          >
            Login
          </Link>
        </div>

        {/* ✅ Close button */}
        <button
          onClick={onClose}
          className="mt-4 text-sm text-gray-400 hover:text-gray-200 w-full text-center"
        >
          Close
        </button>
      </div>
    </div>,
    document.body
  );
};

export default Chatpop;
